import axios from 'axios'
import env from '@/env.js'
import {
  requestSuccessHandler,
  requestFailureHandler,
  responseSuccessHandler,
  responseFailureHandler
} from './util.js'

function mountDefaultInterceptors (ins) {
  ins.interceptors.request.use(requestSuccessHandler, requestFailureHandler)
  ins.interceptors.response.use(responseSuccessHandler, responseFailureHandler)
}

export let conf = axios.create({
  baseURL: env.nutsbpConfigUrl
})
export let dcV1 = axios.create({
  baseURL: env.apiUrlV1
})
export let dcV2 = axios.create({
  baseURL: env.apiUrlV2
})
export let dcV2Graphql = axios.create({
  baseURL: `${env.apiUrlV2}/api/graphql`
})
export let nutsbpV2 = axios.create({
  baseURL: env.editorApiUrlV2
})
export let ranch = axios.create({
  baseURL: env.ranchApiUrl
})
mountDefaultInterceptors(axios)
mountDefaultInterceptors(conf)
mountDefaultInterceptors(dcV1)
mountDefaultInterceptors(dcV2)
mountDefaultInterceptors(dcV2Graphql)
mountDefaultInterceptors(nutsbpV2)
mountDefaultInterceptors(ranch)



// WEBPACK FOOTER //
// ./src/api/index.js